const TAG_CATEGORIES = [
  {
    value: "SKILL",
    label: "Skills",
  },
  {
    value: "DISCIPLINE",
    label: "Disciplines",
  },
  {
    value: "LANGUAGE",
    label: "Languages",
  },
  {
    value: "INTEREST",
    label: "Interests",
  },
  {
    value: "TOPIC",
    label: "Topics",
  },
  {
    value: "BADGE",
    label: "Badges",
  },
  {
    value: "ENGINEERING_LEVEL",
    label: "Engineering Levels",
  },
  {
    value: "NOT_SELECTED_APPLICATION_REASON",
    label: "Application Rejection Reasons",
  },
];

export default TAG_CATEGORIES;
